/**
 * nester-claims-counter.js
 *
 * Shared counter module used by:
 *   - nester-free-gift-progress.js  (Free Gift Card section)
 *   - floating-add-to-cart.js       (Floating ATC bar)
 *
 * Exposes window.NesterClaimsCounter with:
 *   .getClaimed()          → current claimed count (number, 60–80)
 *   .nextClaimed(n)        → next count in cycle
 *   .onTick(callback)      → register a callback fired every 30 s with new claimed count
 *   .offTick(callback)     → unregister a callback
 *
 * Constants (cycle: 85 → 86 → 87 → … → 98 → 85 → …):
 *   STORAGE_KEY  = 'nester_gift_counter'
 *   INCREMENT    = 1
 *   INTERVAL_MS  = 30000  (30 seconds)
 *   MIN          = 85
 *   MAX          = 98
 */

(function (global) {
  'use strict';

  if (global.NesterClaimsCounter) return; // already loaded

  var STORAGE_KEY  = 'nester_gift_counter_v4';
  var INCREMENT    = 1;
  var INTERVAL_MS  = 30 * 1000;
  var MIN_CLAIMED  = 80;
  var MAX_CLAIMED  = 90;

  /* ── Storage helpers ──────────────────────────────────────────── */
  function getStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }

  function setStored(count, timestamp) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify({ count: count, timestamp: timestamp }));
    } catch (e) {}
  }

  /* ── Cycle helper ─────────────────────────────────────────────── */
  function nextCount(count) {
    var next = count + INCREMENT;
    return next > MAX_CLAIMED ? MIN_CLAIMED : next;
  }

  /* ── Resolve current count (applying any elapsed intervals) ───── */
  function resolveCount() {
    var now  = Date.now();
    var data = getStored();

    if (!data) {
      var steps   = (MAX_CLAIMED - MIN_CLAIMED) / INCREMENT;
      var initial = MIN_CLAIMED + Math.floor(Math.random() * (steps + 1)) * INCREMENT;
      setStored(initial, now);
      return initial;
    }

    var elapsed   = now - (data.timestamp || now);
    var intervals = Math.floor(elapsed / INTERVAL_MS);
    var count     = data.count || MIN_CLAIMED;

    for (var i = 0; i < intervals; i++) {
      count = nextCount(count);
    }

    if (intervals > 0) {
      setStored(count, data.timestamp + intervals * INTERVAL_MS);
    }

    return count;
  }

  /* ── Shared live tick ─────────────────────────────────────────── */
  var _currentCount = resolveCount();
  var _listeners    = [];
  var _timerStarted = false;

  function startTick() {
    if (_timerStarted) return;
    _timerStarted = true;
    setInterval(function () {
      _currentCount = nextCount(_currentCount);
      setStored(_currentCount, Date.now());
      for (var i = 0; i < _listeners.length; i++) {
        try { _listeners[i](_currentCount); } catch (e) {}
      }
    }, INTERVAL_MS);
  }

  /* ── Public API ───────────────────────────────────────────────── */
  global.NesterClaimsCounter = {
    getClaimed: function () { return _currentCount; },
    nextClaimed: nextCount,
    onTick: function (cb) {
      if (typeof cb === 'function' && _listeners.indexOf(cb) === -1) {
        _listeners.push(cb);
      }
      startTick();
    },
    offTick: function (cb) {
      var idx = _listeners.indexOf(cb);
      if (idx > -1) _listeners.splice(idx, 1);
    }
  };

})(window);
